import styled from 'styled-components';
import Modal from '../../../Modal';

export const Cities = styled(Modal)`
  max-width: 736px;

  @media (max-width: 768px) {
    max-width: 650px;
  }

  @media (max-width: 767px), (orientation: landscape) and (max-height: 500px) {
    padding-bottom: 0;
    height: 100%;
    margin: 0;
    max-width: none;
    min-height: calc(100 * var(--full-vh));
  }

  .ant-modal-body {
    padding: 0;

    @media (max-width: 767px), (orientation: landscape) and (max-height: 500px) {
      min-height: calc(100 * var(--full-vh));
    }
  }

  .ant-modal-content {
    @media (max-width: 767px), (orientation: landscape) and (max-height: 500px) {
      min-height: calc(100 * var(--full-vh));
      border-radius: 0;
    }
  }
`;
